// All logs go through here for easier mocking / stubbing
/* eslint-disable no-console */
export const log = (msg) => {
    console.log(msg);
};
export const logWarn = (msg) => {
    console.warn(msg);
};
export const logError = (msg) => {
    console.error(msg);
};
/* eslint-enable no-console */
//# sourceMappingURL=log.js.map